import { default as module } from './AbstractModule';
import { $document } from '../utils/environment'
import { EVENT as SCROLL_EVENT } from '../scroll/Scroll'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggle: 'toggle'
            }
        }
    }

    toggle(e) {
        let el = e.currentTarget
        let parent = el.parentNode
        let content = this.$('content', parent)

        if(parent.classList.contains('is-active')) {
            TweenMax.to(content, .5, { height: 0, ease: Power2.easeOut, onComplete: () => {
                content.style.display = '';
                this.call('update', null, 'Scroll')
            } })

            parent.classList.remove('is-active')
        } else {
            // this.closeAll()

            parent.classList.add('is-active')
            content.style.height = '';
            content.style.display = 'block';
            let contentBCR = content.getBoundingClientRect()
            TweenMax.fromTo(content, .5, { height: 0 }, { height: contentBCR.height, ease: Power2.easeOut, onComplete: () => {
                // this.scrollTo(el)
                this.call('update', null, 'Scroll')
            } })
        }
    }

    scrollTo(target) {
        let offset = window.innerWidth > 1000 ? -100 : -160;
        let options = {
            targetElem: target,
            targetOffset: offset
        }

        this.call('scrollTo', options, 'Scroll')
    }

    closeAll() {
        for(let item of Array.from(this.$('content'))) {
            if(item.parentNode.classList.contains('is-active')) {
                TweenMax.to(item, .5, { height: 0, ease: Power2.easeOut, onComplete: () => {
                    item.style.display = '';
                } })

                item.parentNode.classList.remove('is-active')
            }
        }
    }
}
